<template>
  <MediumModal
    :is-open="open"
    @close="close"
  >
    <template #header>
      {{ titleText }}
    </template>

    <div
      v-if="Object.keys(errors).length"
      class="rounded-md bg-red-50 p-4"
    >
      <div class="flex">
        <div class="shrink-0">
          <XCircleIcon
            class="h-5 w-5 text-red-400"
            aria-hidden="true"
          />
        </div>
        <div class="ml-3">
          <h3 class="text-sm font-medium text-red-800">There were errors with your submission</h3>
          <div
            v-if="false"
            class="mt-2 text-sm text-red-600"
          >
            <ul
              role="list"
              class="list-disc pl-5 space-y-1"
            >
              <li>No record in MMUR</li>
              <li>Please add a valid birthday</li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div
      class="mt-4"
      v-if="currentStep === 'main'"
    >
      <div class="grid grid-cols-2 gap-5">
        <div class="input-group">
          <label for="first_name"> First Name </label>
          <div class="mt-1 relative rounded-md shadow-sm">
            <input
              v-model="form.first_name"
              type="text"
              id="first_name"
              placeholder="First Name"
              :class="{
                'block w-full pr-10 border-red-200 text-red-800 placeholder-red-600 focus:outline-none focus:ring-red-400 focus:border-red-400 sm:text-sm rounded-md':
                  getErrors('first_name')
              }"
            />
            <div
              v-if="getErrors('first_name')"
              class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
            >
              <ExclamationCircleIcon
                class="h-5 w-5 text-red-400"
                aria-hidden="true"
              />
            </div>
          </div>
          <p
            v-if="getErrors('first_name')"
            class="mt-2 text-sm text-red-600"
          >
            {{ getErrors('first_name') }}
          </p>
        </div>
        <div class="input-group">
          <label for="last_name"> Last Name </label>
          <div class="mt-1 relative rounded-md shadow-sm">
            <input
              v-model="form.last_name"
              type="text"
              id="last_name"
              placeholder="Last Name"
              :class="{
                'block w-full pr-10 border-red-200 text-red-800 placeholder-red-600 focus:outline-none focus:ring-red-400 focus:border-red-400 sm:text-sm rounded-md':
                  getErrors('last_name')
              }"
            />
            <div
              v-if="getErrors('last_name')"
              class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
            >
              <ExclamationCircleIcon
                class="h-5 w-5 text-red-400"
                aria-hidden="true"
              />
            </div>
          </div>
          <p
            v-if="getErrors('last_name')"
            class="mt-2 text-sm text-red-600"
          >
            {{ getErrors('last_name') }}
          </p>
        </div>
        <div class="input-group">
          <label for="email_address"> Email Address </label>
          <div class="mt-1 relative rounded-md shadow-sm">
            <input
              v-model="form.email"
              type="text"
              id="email_address"
              placeholder="you@example.com"
              :class="{
                'block w-full pr-10 border-red-200 text-red-800 placeholder-red-600 focus:outline-none focus:ring-red-400 focus:border-red-400 sm:text-sm rounded-md':
                  getErrors('email')
              }"
            />
            <div
              v-if="getErrors('email')"
              class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
            >
              <ExclamationCircleIcon
                class="h-5 w-5 text-red-400"
                aria-hidden="true"
              />
            </div>
          </div>
          <p
            v-if="getErrors('email')"
            class="mt-2 text-sm text-red-600"
          >
            {{ getErrors('email') }}
          </p>
        </div>
        <div class="input-group">
          <label for="phone_number"> Phone Number </label>
          <div class="mt-1 relative rounded-md shadow-sm">
            <input
              v-model="form.phone"
              type="text"
              id="phone_number"
              placeholder="555-555-5555"
              v-maska="'+1 (###) ###-####'"
              :class="{
                'block w-full pr-10 border-red-200 text-red-800 placeholder-red-600 focus:outline-none focus:ring-red-400 focus:border-red-400 sm:text-sm rounded-md':
                  getErrors('phone')
              }"
            />
            <div
              v-if="getErrors('phone')"
              class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
            >
              <ExclamationCircleIcon
                class="h-5 w-5 text-red-400"
                aria-hidden="true"
              />
            </div>
          </div>
          <p
            v-if="getErrors('phone')"
            class="mt-2 text-sm text-red-600"
          >
            {{ getErrors('phone') }}
          </p>
        </div>
        <!--                <div class="input-group">-->
        <!--                    <label for="mmur_id">-->
        <!--                        Patient #-->
        <!--                    </label>-->
        <!--                    <div class="mt-1 relative rounded-md shadow-sm">-->
        <!--                        <input v-model="form.medical.card_number" type="text" id="mmur_id" :class="{ 'block w-full pr-10 border-red-200 text-red-800 placeholder-red-600 focus:outline-none focus:ring-red-400 focus:border-red-400 sm:text-sm rounded-md': getErrors('medical.card_number') }" />-->
        <!--                        <div v-if="getErrors('medical.card_number')" class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">-->
        <!--                            <ExclamationCircleIcon class="h-5 w-5 text-red-400" aria-hidden="true" />-->
        <!--                        </div>-->
        <!--                    </div>-->
        <!--                    <p v-if="getErrors('medical.card_number')" class="mt-2 text-sm text-red-600">-->
        <!--                        {{ getErrors('medical.card_number') }}-->
        <!--                    </p>-->
        <!--                </div>-->
        <div class="input-group">
          <label for="birthday"> Birthday </label>
          <div class="mt-1 relative rounded-md shadow-sm">
            <input
              v-model="form.birthdate"
              type="text"
              id="birthday"
              placeholder="01/01/1900"
              v-maska="'##/##/####'"
              :class="{
                'block w-full pr-10 border-red-200 text-red-800 placeholder-red-600 focus:outline-none focus:ring-red-400 focus:border-red-400 sm:text-sm rounded-md':
                  getErrors('birthdate')
              }"
            />
            <div
              v-if="getErrors('birthdate')"
              class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
            >
              <ExclamationCircleIcon
                class="h-5 w-5 text-red-400"
                aria-hidden="true"
              />
            </div>
          </div>
          <p
            v-if="getErrors('birthdate')"
            class="mt-2 text-sm text-red-600"
          >
            {{ getErrors('birthdate') }}
          </p>
        </div>
        <div class="input-group">
          <label for="license_number"> License ID </label>
          <div class="mt-1 relative rounded-md shadow-sm">
            <input
              v-model="form.license_number"
              type="text"
              id="license_number"
              placeholder="License ID"
              :class="{
                'block w-full pr-10 border-red-200 text-red-800 placeholder-red-600 focus:outline-none focus:ring-red-400 focus:border-red-400 sm:text-sm rounded-md':
                  getErrors('license_number')
              }"
            />
            <div
              v-if="getErrors('license_number')"
              class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
            >
              <ExclamationCircleIcon
                class="h-5 w-5 text-red-400"
                aria-hidden="true"
              />
            </div>
          </div>
          <p
            v-if="getErrors('license_number')"
            class="mt-2 text-sm text-red-600"
          >
            {{ getErrors('license_number') }}
          </p>
        </div>
        <div class="input-group col-span-2 border-b border-gray-400 pb-3">
          <fieldset>
            <div class="flex">
              <label class="w-20">Loyalty?</label>
              <div class="flex items-center">
                <input
                  v-model="form.has_loyalty"
                  :value="true"
                  name="loyalty"
                  type="radio"
                  class="focus:ring-blue-600 h-5 w-5 text-blue-600 border-gray-400"
                />
                <label
                  for="loyalty"
                  class="block font-medium text-gray-700 px-3"
                >
                  Yes
                </label>
              </div>
              <div class="flex items-center">
                <input
                  v-model="form.has_loyalty"
                  :value="false"
                  name="loyalty"
                  type="radio"
                  class="focus:ring-blue-600 h-5 w-5 text-blue-600 border-gray-400"
                />
                <label
                  for="loyalty"
                  class="block font-medium text-gray-700 px-3"
                >
                  No
                </label>
              </div>
            </div>
            <p
              v-if="getErrors('has_loyalty')"
              class="mt-2 text-sm text-red-600"
            >
              {{ getErrors('has_loyalty') }}
            </p>
          </fieldset>
        </div>
        <div class="input-group col-span-2 border-b border-gray-400 pb-3">
          <fieldset>
            <div class="flex">
              <label class="w-20">Employee?</label>
              <div class="flex items-center">
                <input
                  v-model="form.is_employee"
                  :value="true"
                  name="employee"
                  type="radio"
                  class="focus:ring-blue-600 h-5 w-5 text-blue-600 border-gray-400"
                />
                <label
                  for="employee"
                  class="block font-medium text-gray-700 px-3"
                >
                  Yes
                </label>
              </div>
              <div class="flex items-center">
                <input
                  v-model="form.is_employee"
                  :value="false"
                  name="employee"
                  type="radio"
                  class="focus:ring-blue-600 h-5 w-5 text-blue-600 border-gray-400"
                />
                <label
                  for="employee"
                  class="block font-medium text-gray-700 px-3"
                >
                  No
                </label>
              </div>
            </div>
            <p
              v-if="getErrors('is_employee')"
              class="mt-2 text-sm text-red-600"
            >
              {{ getErrors('is_employee') }}
            </p>
          </fieldset>
        </div>
        <div class="input-group col-span-2 border-b border-gray-400 pb-3">
          <fieldset>
            <div class="flex">
              <label class="w-20">Gender</label>
              <div class="flex items-center">
                <input
                  v-model="form.gender"
                  value="male"
                  name="gender"
                  type="radio"
                  class="focus:ring-blue-600 h-5 w-5 text-blue-600 border-gray-400"
                />
                <label
                  for="gender"
                  class="block font-medium text-gray-700 px-3"
                >
                  Male
                </label>
              </div>
              <div class="flex items-center">
                <input
                  v-model="form.gender"
                  value="female"
                  name="gender"
                  type="radio"
                  class="focus:ring-blue-600 h-5 w-5 text-blue-600 border-gray-400"
                />
                <label
                  for="gender"
                  class="block font-medium text-gray-700 px-3"
                >
                  Female
                </label>
              </div>
              <div class="flex items-center">
                <input
                  v-model="form.gender"
                  value="other"
                  name="gender"
                  type="radio"
                  class="focus:ring-blue-600 h-5 w-5 text-blue-600 border-gray-400"
                />
                <label
                  for="gender"
                  class="block font-medium text-gray-700 px-3"
                >
                  N/A
                </label>
              </div>
            </div>
            <p
              v-if="getErrors('gender')"
              class="mt-2 text-sm text-red-600"
            >
              {{ getErrors('gender') }}
            </p>
          </fieldset>
        </div>
        <div class="input-group col-span-2 border-b border-gray-400 pb-3">
          <fieldset>
            <div class="flex">
              <label class="w-20">Discount</label>
              <div class="flex items-center">
                <input
                  v-model="form.is_veteran"
                  :value="false"
                  name="male"
                  type="checkbox"
                  class="focus:ring-blue-600 h-5 w-5 text-blue-600 border-gray-400"
                />
                <label
                  for="male"
                  class="block font-medium text-gray-700 px-3"
                >
                  Veteran
                </label>
              </div>
              <div class="flex items-center">
                <input
                  v-model="form.has_industry_discount"
                  :value="false"
                  name="female"
                  type="checkbox"
                  class="focus:ring-blue-600 h-5 w-5 text-blue-600 border-gray-400"
                />
                <label
                  for="female"
                  class="block font-medium text-gray-700 px-3"
                >
                  Ind. Dis.
                </label>
              </div>
            </div>
            <p
              v-if="getErrors('is_veteran')"
              class="mt-2 text-sm text-red-600"
            >
              {{ getErrors('is_veteran') }}
            </p>
            <p
              v-if="getErrors('has_industry_discount')"
              class="mt-2 text-sm text-red-600"
            >
              {{ getErrors('has_industry_discount') }}
            </p>
          </fieldset>
        </div>
        <div class="input-group col-span-2">
          <fieldset>
            <div class="flex">
              <label class="w-20">Type</label>
              <div class="flex items-center">
                <input
                  v-model="form.is_recreational"
                  :value="false"
                  name="is_recreational"
                  type="radio"
                  class="focus:ring-blue-600 h-5 w-5 text-blue-600 border-gray-400"
                />
                <label
                  for="is_recreational"
                  class="block font-medium text-gray-700 px-3"
                >
                  Medical
                </label>
              </div>
              <div class="flex items-center">
                <input
                  v-model="form.is_recreational"
                  :value="true"
                  name="is_recreational"
                  type="radio"
                  class="focus:ring-blue-600 h-5 w-5 text-blue-600 border-gray-400"
                />
                <label
                  for="is_recreational"
                  class="block font-medium text-gray-700 px-3"
                >
                  Recreational
                </label>
              </div>
            </div>
            <p
              v-if="getErrors('is_recreational')"
              class="mt-2 text-sm text-red-600"
            >
              {{ getErrors('is_recreational') }}
            </p>
          </fieldset>
        </div>
        <div
          v-if="!form.is_recreational"
          class="input-group"
        >
          <label for="patient_number"> Patient # </label>
          <div class="mt-1 relative rounded-md shadow-sm">
            <div class="absolute inset-y-0 left-0 flex items-center">
              <label
                for="medical_source"
                class="sr-only"
              >
                Medical Source
              </label>
              <select
                v-model="form.medical.source"
                id="medical_source"
                class="h-full rounded-md border-0 bg-transparent py-0 pl-3 pr-7"
              >
                <option :value="null">Source</option>
                <option
                  v-for="source in medicalSources"
                  :key="source.id"
                  :value="source.name"
                >
                  {{ source.display_name }}
                </option>
              </select>
            </div>
            <input
              v-model="form.medical.card_number"
              type="text"
              id="patient_number"
              placeholder="Patient ID"
              class="pl-20"
              :class="{
                'block w-full pr-10 border-red-200 text-red-800 placeholder-red-600 focus:outline-none focus:ring-red-400 focus:border-red-400 sm:text-sm rounded-md':
                  getErrors('medical.source') || getErrors('medical.card_number')
              }"
            />
            <p
              v-if="getErrors('medical.source')"
              class="mt-2 text-sm text-red-600"
            >
              {{ getErrors('medical.source') }}
            </p>
            <p
              v-if="getErrors('medical.card_number')"
              class="mt-2 text-sm text-red-600"
            >
              {{ getErrors('medical.card_number') }}
            </p>
          </div>
        </div>
        <div
          v-if="!form.is_recreational"
          class="input-group col-span-2"
        >
          <fieldset>
            <div class="flex">
              <div class="flex items-center">
                <input
                  v-model="form.medical.has_caregivers"
                  :value="true"
                  name="is_recreational"
                  type="checkbox"
                  class="focus:ring-blue-600 h-5 w-5 text-blue-600 border-gray-400"
                />
                <label
                  for="is_recreational"
                  class="block font-medium text-gray-700 px-3"
                >
                  Caregiver?
                </label>
              </div>
            </div>
          </fieldset>
        </div>
      </div>
      <div
        v-if="Array.isArray(form.medical.caregivers)"
        v-for="(caregiver, index) in form.medical.caregivers"
        class="grid grid-cols-2 gap-5 mt-4"
      >
        <div class="input-group">
          <div class="mt-1 relative rounded-md shadow-sm">
            <input
              v-model="form.medical.caregivers[index].card_number"
              type="text"
              placeholder="Caregiver Patient ID"
              :class="{
                'block w-full pr-10 border-red-200 text-red-800 placeholder-red-600 focus:outline-none focus:ring-red-400 focus:border-red-400 sm:text-sm rounded-md':
                  getErrors(`medical.caregivers.${index}.card_number`)
              }"
            />
            <div
              v-if="getErrors(`medical.caregivers.${index}.card_number`)"
              class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
            >
              <ExclamationCircleIcon
                class="h-5 w-5 text-red-400"
                aria-hidden="true"
              />
            </div>
          </div>
          <p
            v-if="getErrors(`medical.caregivers.${index}.card_number`)"
            class="mt-2 text-sm text-red-600"
          >
            {{ getErrors(`medical.caregivers.${index}.card_number`) }}
          </p>
        </div>
        <div class="input-group">
          <div class="mt-1 relative rounded-md shadow-sm">
            <input
              v-model="form.medical.caregivers[index].expires_at"
              type="text"
              placeholder="Caregiver Medical Exp Date"
              v-maska="'##/##/####'"
              :class="{
                'block w-full pr-10 border-red-200 text-red-800 placeholder-red-600 focus:outline-none focus:ring-red-400 focus:border-red-400 sm:text-sm rounded-md':
                  getErrors(`medical.caregivers.${index}.expires_at`)
              }"
            />
            <div
              v-if="getErrors(`medical.caregivers.${index}.expires_at`)"
              class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
            >
              <ExclamationCircleIcon
                class="h-5 w-5 text-red-400"
                aria-hidden="true"
              />
            </div>
          </div>
          <p
            v-if="getErrors(`medical.caregivers.${index}.expires_at`)"
            class="mt-2 text-sm text-red-600"
          >
            {{ getErrors(`medical.caregivers.${index}.expires_at`) }}
          </p>
        </div>
      </div>
    </div>

    <div
      class="mt-4"
      v-if="currentStep === 'address'"
    >
      <div class="grid grid-cols-2 gap-5">
        <div class="input-group">
          <label for="street_1"> Street 1 </label>
          <div class="mt-1 relative rounded-md shadow-sm">
            <input
              v-model="form.address.street_1"
              type="text"
              id="street_1"
              :class="{
                'block w-full pr-10 border-red-200 text-red-800 placeholder-red-600 focus:outline-none focus:ring-red-400 focus:border-red-400 sm:text-sm rounded-md':
                  getErrors('address.street_1')
              }"
            />
            <div
              v-if="getErrors('address.street_1')"
              class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
            >
              <ExclamationCircleIcon
                class="h-5 w-5 text-red-400"
                aria-hidden="true"
              />
            </div>
          </div>
          <p
            v-if="getErrors('address.street_1')"
            class="mt-2 text-sm text-red-600"
          >
            {{ getErrors('address.street_1') }}
          </p>
        </div>
        <div class="input-group">
          <label for="street_2"> Street 2 </label>
          <div class="mt-1 relative rounded-md shadow-sm">
            <input
              v-model="form.address.street_2"
              type="text"
              id="street_2"
              :class="{
                'block w-full pr-10 border-red-200 text-red-800 placeholder-red-600 focus:outline-none focus:ring-red-400 focus:border-red-400 sm:text-sm rounded-md':
                  getErrors('address.street_2')
              }"
            />
            <div
              v-if="getErrors('address.street_2')"
              class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
            >
              <ExclamationCircleIcon
                class="h-5 w-5 text-red-400"
                aria-hidden="true"
              />
            </div>
          </div>
          <p
            v-if="getErrors('address.street_2')"
            class="mt-2 text-sm text-red-600"
          >
            {{ getErrors('address.street_2') }}
          </p>
        </div>
        <div class="input-group">
          <label for="city"> City </label>
          <div class="mt-1 relative rounded-md shadow-sm">
            <input
              v-model="form.address.city"
              type="text"
              id="city"
              :class="{
                'block w-full pr-10 border-red-200 text-red-800 placeholder-red-600 focus:outline-none focus:ring-red-400 focus:border-red-400 sm:text-sm rounded-md':
                  getErrors('address.city')
              }"
            />
            <div
              v-if="getErrors('address.city')"
              class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
            >
              <ExclamationCircleIcon
                class="h-5 w-5 text-red-400"
                aria-hidden="true"
              />
            </div>
          </div>
          <p
            v-if="getErrors('address.city')"
            class="mt-2 text-sm text-red-600"
          >
            {{ getErrors('address.city') }}
          </p>
        </div>
        <div class="input-group">
          <label for="state"> State </label>
          <select
            id="state"
            v-model="form.address.state"
            name="state"
          >
            <option :value="null">Select a state</option>
            <option
              v-for="(state, key) in states"
              :value="key"
            >
              {{ state }}
            </option>
          </select>
          <p
            v-if="getErrors('address.state', form)"
            class="input-error"
          >
            {{ getErrors('address.state', form) }}
          </p>
        </div>
        <div class="input-group">
          <label for="zip"> Postal Code </label>
          <div class="mt-1 relative rounded-md shadow-sm">
            <input
              v-model="form.address.zip"
              type="text"
              id="zip"
              :class="{
                'block w-full pr-10 border-red-200 text-red-800 placeholder-red-600 focus:outline-none focus:ring-red-400 focus:border-red-400 sm:text-sm rounded-md':
                  getErrors('address.zip')
              }"
            />
            <div
              v-if="getErrors('address.zip')"
              class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
            >
              <ExclamationCircleIcon
                class="h-5 w-5 text-red-400"
                aria-hidden="true"
              />
            </div>
          </div>
          <p
            v-if="getErrors('address.zip')"
            class="mt-2 text-sm text-red-600"
          >
            {{ getErrors('address.zip') }}
          </p>
        </div>
      </div>
    </div>

    <template #footer>
      <button
        v-if="hasPrevStep"
        @click.prevent="prevStep()"
        type="button"
        class="mr-3 inline-flex items-center px-4 py-2 rounded-md border border-gray-400 px-4 py-2 bg-gray-100 font-medium text-gray-700 shadow-sm hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-600 sm:mt-0 w-auto text-sm"
      >
        Previous
      </button>

      <button
        v-if="hasNextStep"
        @click.prevent="nextStep()"
        type="button"
        class="mr-3 inline-flex items-center px-4 py-2 rounded-md border border-gray-400 px-4 py-2 bg-gray-100 font-medium text-gray-700 shadow-sm hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-600 sm:mt-0 w-auto text-sm"
      >
        Next
      </button>

      <button
        v-if="showSubmit"
        @click.prevent="submit()"
        :disabled="creating"
        type="button"
        class="mr-3 inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-gray-100 bg-blue-600 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-600"
      >
        {{ submitText }}
      </button>

      <button
        @click="cancel()"
        type="button"
        class="mt-3 inline-flex justify-center rounded-md border border-gray-400 px-4 py-2 bg-gray-100 font-medium text-gray-700 shadow-sm hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-600 sm:mt-0 w-auto text-sm"
      >
        Cancel
      </button>
    </template>
  </MediumModal>
</template>

<script>
import MediumModal from '@/Components/Modals/MediumModal.vue'
import { ExclamationCircleIcon, XCircleIcon } from '@heroicons/vue/solid'
import getsErrors from '@/Mixins/getsErrors'
import _date from '@/Filters/Date'

export default {
  mixins: [getsErrors],

  components: {
    MediumModal,
    ExclamationCircleIcon,
    XCircleIcon
  },

  props: {
    open: {
      type: Boolean,
      default: false
    },
    titleText: {
      type: String,
      default: 'Create Customer'
    },
    actionText: {
      type: String,
      default: 'Save'
    },
    /**
     * A list of simple integration objects that act as medical sources.
     * e.g. [ { id: 1, name: 'metrc' } ]
     */
    medicalSources: {
      type: Array,
      default() {
        return []
      }
    },
    requireAddress: {
      type: Boolean,
      default: true
    },
    /**
     * An object of default customer details to use in search. Produced from ScanData.
     */
    defaultDetails: {
      type: Object,
      default() {
        return null
      }
    }
  },

  emits: ['update:open', 'created'],

  data() {
    let steps = ['main']

    if (this.requireAddress) {
      steps.push('address')
    }

    let form = {
      id: null,
      first_name: null,
      last_name: null,
      email: null,
      phone: null,
      license_type: null,
      license_number: null,
      license_expires_at: null,
      birthdate: null,
      has_loyalty: false,
      is_employee: false,
      gender: null,
      is_recreational: true,
      is_veteran: false,
      has_industry_discount: false,
      medical: {
        source: null,
        card_number: null,
        has_caregivers: false,
        caregivers: []
      },
      address: {
        street_1: null,
        street_2: null,
        city: null,
        state: null,
        zip: null
      }
    }

    if (this.medicalSources.length > 0) {
      form.medical.source = this.medicalSources[0].name
    }

    return {
      creating: false,
      stepIndex: 0,
      steps,
      form: this.$inertia.form(form)
    }
  },

  watch: {
    defaultDetails: {
      handler(val) {
        if (val) {
          this.mergeDetailsIntoForm(val)
        } else {
          this.reset()
        }
      },
      deep: true
    },
    'form.medical.has_caregivers': function (newVal, oldVal) {
      if (newVal) {
        this.toggleOnCaregivers()
      } else {
        this.toggleOffCaregivers()
      }
    },
    'form.is_recreational': function (newVal, oldVal) {
      if (newVal) {
        this.form.medical.has_caregivers = false
      }
    }
  },

  computed: {
    states() {
      return this.$page.props.util.states
    },
    currentStep() {
      return this.steps[this.stepIndex]
    },
    hasNextStep() {
      return this.stepIndex + 1 < this.steps.length
    },
    hasPrevStep() {
      return this.stepIndex !== 0
    },
    errors() {
      return this.$page.props.errors.createCustomer || {}
    },
    showSubmit() {
      return this.stepIndex + 1 >= this.steps.length
    },
    submitText() {
      if (this.creating) {
        return 'Saving...'
      }

      return this.actionText
    }
  },

  methods: {
    mergeDetailsIntoForm(details) {
      this.form.id = details.id || null
      this.form.first_name = details.first_name
      this.form.last_name = details.last_name
      this.form.email = details.email
      this.form.phone = details.phone
      this.form.license_type = details.license_type || this.form.license_type
      this.form.license_number = details.license_number || this.form.license_number
      this.form.license_expires_at = details.license_expires_at || details.expires_at || this.form.license_expires_at
      this.form.is_recreational = 'is_recreational' in details ? details.is_recreational : this.form.is_recreational
      this.form.has_loyalty = 'has_loyalty' in details ? details.has_loyalty : this.form.has_loyalty
      this.form.is_employee = 'is_employee' in details ? details.is_employee : this.form.is_employee
      this.form.is_veteran = 'is_veteran' in details ? details.is_veteran : this.form.is_veteran
      this.form.has_industry_discount =
        'has_industry_discount' in details ? details.has_industry_discount : this.form.has_industry_discount
      this.form.birthdate = details.birthdate
        ? _date(details.birthdate, { day: '2-digit', month: '2-digit', year: 'numeric' })
        : null
      this.form.gender = details.gender

      if (details.medical) {
        this.form.medical = { ...details.medical }
        this.form.medical.has_caregivers = !!details.medical.caregivers
      }

      let address = details.address ? details.address : details

      this.form.address.street_1 = address.street_1 || null
      this.form.address.street_2 = address.street_2 || null
      this.form.address.city = address.city || null
      this.form.address.state = address.state || null
      this.form.address.zip = address.zip || null
    },
    toggleOnCaregivers() {
      console.log('toggle on caregivers', this.form.medical.caregivers)

      if (this.form.medical.caregivers) {
        return
      }

      this.form.medical.caregivers = [
        {
          card_number: null,
          expires_at: null
        }
      ]
    },
    toggleOffCaregivers() {
      this.form.medical.caregivers = null
    },
    nextStep() {
      if (typeof this.steps[this.stepIndex + 1] === 'undefined') {
        return
      }

      this.stepIndex++
    },
    prevStep() {
      if (this.stepIndex <= 0) {
        return
      }

      this.stepIndex--
    },
    reset() {
      this.form.clearErrors()
      this.form.reset()
      this.stepIndex = 0
    },
    close() {
      this.$emit('update:open', false)
    },
    cancel() {
      this.reset()
      this.close()
    },
    submit() {
      this.creating = true

      this.form.post(route('customers.store'), {
        errorBag: 'createCustomer',
        onSuccess: (response) => {
          this.creating = false
          this.$emit('created')
          this.reset()
        },
        onFinish: (response) => {
          this.creating = false
        }
      })
    }
  }
}
</script>
